import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {
  IHttpErrorPayload,
  HttpRequestPayload,
  IHttpSuccessPayload,
} from '@core/models';
import { HttpProviderService } from 'src/app/core/services/http-provider/http-provider.service';
import { RepaymentSchedule } from '../models/repayment-schedule.model';

@Injectable({
  providedIn: 'root',
})
export class RepaymentScheduleService {
  constructor(private httpProvider: HttpProviderService) {}
}
